import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal from 'components/modal_wrapper';
import BookingSummary from 'tenants/sealink/booking_summary';

const StickySummary = ({ reference, total, hasReservation }) => {
  const [show, setShow] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();
  const onOverviewPage = pathname === '/bookings';

  useEffect(() => {
    setShow(false);
  }, [pathname]);

  return (
    <>
      <div className="sticky-summary" onClick={() => setShow(true)}>
        <div>
          <i className="fas fa-chevron-up" /> Booking summary
        </div>
        {hasReservation && onOverviewPage ? (
          <button
            type="button"
            className="btn btn-primary py-2"
            onClick={(e) => {
              e.stopPropagation();
              history.push('/bookings/checkout');
            }}
          >
            Checkout
          </button>
        ) : (
          <div className="sticky-summary__total fw-bold text-xx-large">
            {total}
          </div>
        )}
      </div>
      <Modal
        id="sticky-summary"
        className="summary-modal"
        fullscreen
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Booking Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reference && (
            <div className="mb-3">
              Booking Reference:{' '}
              <span className="summary-modal__reference">{reference}</span>
            </div>
          )}
          <BookingSummary />
        </Modal.Body>
      </Modal>
    </>
  );
};

StickySummary.propTypes = {
  reference: PropTypes.string,
  total: PropTypes.string,
  hasReservation: PropTypes.bool,
};

export default StickySummary;
